import { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import store from "redux/store";

import {
  LOGIN_SUCCESS,
  LOGOUT,
  HIDE_MODAL,
  MESSAGE_INFO,
  MESSAGE_SUCCES,
  SET_USER,
} from "actions/types";
import { showLoader, hideLoader } from "actions/types";
import Company from "api/Company";

export default function CompanyProviderRequestView(props) {
  const { t, i18n } = useTranslation("modals");
  const [open, setOpen] = useState(true);

  const saveEvent = (event) => {
    event.preventDefault();
    connectCompanyByCode();
  };

  const handleClose = () => {
    setOpen(false);
    if (props.onHideEvent) {
      props.onHideEvent();
    }
  };

  const connectCompanyByCode = async () => {
    try {
      store.dispatch(showLoader());
      const response = await Company.companyCompanyRequest(
        props.modalview.data.id
      );
      store.dispatch({ type: HIDE_MODAL });
      store.dispatch({
        type: MESSAGE_SUCCES,
        message: "Aanvraag is met succes verzonden",
        header: "Aanvraag bedrijfsverkoop profiel",
      });
      if (props.modalview.saveEvent) {
        props.modalview.saveEvent();
      }
      store.dispatch(hideLoader());
    } catch (error) {
      if (error.response.status == 429 && error.response.data.data) {
        store.dispatch({
          type: MESSAGE_INFO,
          message: t("companyproviderrequest.error_" + error.response.status),
          header: "Aanvraag bedrijfsverkoop profiel",
        });
      } else if (error.response.status == 404 && error.response.data.data) {
        store.dispatch({
          type: MESSAGE_INFO,
          message: t("companyproviderrequest.error_" + error.response.status),
          header: "Aanvraag bedrijfsverkoop profiel",
        });
      } else if (error.response.status == 433 && error.response.data.data) {
        store.dispatch({
          type: MESSAGE_INFO,
          message: error.response.data.data.data,
          header: "Aanvraag bedrijfsverkoop profiel",
        });
      }
      store.dispatch(hideLoader());
    }
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={handleClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="overflow-y-auto fixed inset-0 z-10 w-screen">
          <div className="flex justify-center items-end p-4 min-h-full text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="overflow-hidden relative text-left bg-white shadow-xl transition-all transform sm:my-8 sm:w-full sm:max-w-lg">
                <form onSubmit={saveEvent}>
                  <div className="px-4 pt-5 pb-4 sm:p-6">
                    <div className="flex items-center">
                      <div className="flex flex-shrink-0 justify-center items-center mx-auto w-12 h-12 bg-blue-50 rounded-full sm:mx-0 sm:h-10 sm:w-10">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="text-blue-600"
                          viewBox="0 0 16 16"
                        >
                          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
                        </svg>
                      </div>
                      <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                        <Dialog.Title
                          as="h3"
                          className="text-lg font-medium leading-6 text-gray-900"
                        >
                          {props.modalview.header}
                        </Dialog.Title>
                      </div>
                    </div>

                    <div className="mt-4">
                      <p className="mb-4 text-sm text-gray-500">
                        {props.modalview.message}
                      </p>
                      <div className="mb-4">
                        <label
                          htmlFor="providerRequest"
                          className="block text-sm font-medium text-gray-700"
                        >
                          {t("companyproviderrequest.title")}
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="gap-3 px-4 py-3 bg-gray-50 sm:px-6 sm:flex sm:flex-row-reverse">
                    <button type="submit" className="btn-primary">
                      {t("companyproviderrequest.save")}
                    </button>
                    <button
                      type="button"
                      className="btn-secondary"
                      onClick={handleClose}
                    >
                      {t("companyproviderrequest.cancel")}
                    </button>
                  </div>
                </form>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
